import { Loader } from "@mantine/core";
import { SystemEmailRegistryEntry } from "../../../services/admin/systemEmails.service";
import { HeldEmailLoadError } from "./HeldEmailLoadError";
import { SystemEmailRegistryTable } from "./SystemEmailRegistryTable";

interface Props {
  entries: SystemEmailRegistryEntry[];
  filtered: boolean;
  loading: boolean;
  error?: Error | null;
  success: boolean;
}

export function SystemEmailCatalogueResults({
  entries,
  filtered,
  loading,
  error,
  success,
}: Props) {
  if (loading) return <Loader aria-label="Loading system email catalogue" />;
  if (error)
    return <HeldEmailLoadError error={error} title="Catalogue unavailable" />;
  return success ? (
    <SystemEmailRegistryTable entries={entries} filtered={filtered} />
  ) : null;
}
